import { getActiveMagicFrameActive } from '~core/magicFrame';

export const toggleMagicFrameEditMode = () => {
  const magicFrame = getActiveMagicFrameActive();

  if (magicFrame) {
    magicFrame.toggleEditMode();
    // If floating controls are present, reflect the new edit mode state
    if (typeof magicFrame.updateEditMode === 'function') {
      magicFrame.updateEditMode();
    }
  }
};
